var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigurationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.616 16C1.15533 16 0.771 15.846 0.463 15.538C0.155 15.23 0.000666667 14.8453 0 14.384V1.616C0 1.15533 0.154333 0.771 0.463 0.463C0.771667 0.155 1.15567 0.000666667 1.615 0H16.385C16.845 0 17.229 0.154333 17.537 0.463C17.845 0.771667 17.9993 1.156 18 1.616V14.385C18 14.845 17.8457 15.2293 17.537 15.538C17.2283 15.8467 16.8443 16.0007 16.385 16H1.616ZM1.616 15H16.385C16.5383 15 16.6793 14.936 16.808 14.808C16.9367 14.68 17.0007 14.5387 17 14.384V1.616C17 1.462 16.936 1.32067 16.808 1.192C16.68 1.06333 16.539 0.999333 16.385 1H1.615C1.46167 1 1.32067 1.064 1.192 1.192C1.06333 1.32 0.999333 1.46133 1 1.616V14.385C1 14.5383 1.064 14.6793 1.192 14.808C1.32 14.9367 1.461 15.0007 1.615 15M2.5 12.5H6.5V11.5H2.5V12.5ZM11.55 10.289L15.788 6.05L15.075 5.336L11.55 8.886L10.125 7.462L9.437 8.175L11.55 10.289ZM2.5 8.5H6.5V7.5H2.5V8.5ZM2.5 4.5H6.5V3.5H2.5V4.5Z",
    fill: "#9BA4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationIcon);
export default __webpack_public_path__ + "static/media/configuration-icon.be0078b3a666d4ac380795a91f63e4af.svg";
export { ForwardRef as ReactComponent };